import { useFeatureFlags } from 'front-end/src/app/hooks/useFeatureFlags'
import React from 'react'

import { Hotjar } from './Hotjar'

export const ThirdPartyIntegrations: React.FC = () => {
  const { featureFlags } = useFeatureFlags()
  const hotjar = featureFlags?.hotjar

  return (
    <>
      {hotjar?.enabled && hotjar?.site_id && (
        <Hotjar hotjarSiteId={hotjar.site_id} />
      )}
    </>
  )
}
